export const DEMO_TAG_COLOR = '#256FEB';
export const DEMO_TAG_TEXT = 'Demo';

export const TRACKING = {
  RATE_SHOPPER_PROMO_APPLIED: 'RATE_SHOPPER_PROMO_APPLIED',
  RATE_SHOPPER_PROMO_DISMISSED: 'RATE_SHOPPER_PROMO_DISMISSED',
  RATE_SHOPPER_PROMO_SHOWN: 'RATE_SHOPPER_PROMO_SHOWN',
};
